declare global {
    interface Window {
        ValidatorEnable(elm: any, validate: boolean): any;
    }
}

const UpToFiftyCheck = () => {

    var payOptions = $('.payOption-radio-row');
    var mainLink;
    var mainHref;
    var upToFifty = false;

    if (payOptions.length > 1) {
        $('.choiceAnnounce').show();
    }


    function OpenPayModal() {
        var modal = $('#PayModal');
        modal.show();
        $('.modal-overlay').show();
        $('#site-container').addClass('blur');
        $('body').css('overflow', 'hidden');
    }

    function ClosePayModal() {
        var modal = $('#PayModal');
        modal.hide();
        $('.modal-overlay').hide();
        $('#site-container').removeClass('blur');
        $('body').css('overflow', 'auto');
    }

    window.addEventListener("DOMContentLoaded",
        function () {

            var priceStr = document.getElementById('lblGhabelePardakht').innerHTML;
            var price = priceStr.replace("تومان", "").replace("مبلغ قابل پرداخت:", "").replace(/,/g, "");
            var priceNumber = parseInt(price);
            var priceLimit = 50000000;
            upToFifty = priceNumber >= priceLimit;

            mainLink = document.getElementById('lbtnFinishBuy');
            mainHref = mainLink.getAttribute('href');


            var payRadios = document.getElementsByTagName('input');
            var installmentSelected = true;
            for (var j = 0; j < payRadios.length; j++) {

                if (payRadios[j].value === "rbSelect") {
                    payRadios[j].addEventListener('click', radioChange);
                }
            }

            var payOption = document.querySelectorAll('.pay-table-row');
            var checked = false;
            payOption.forEach(function(payRow: HTMLElement) {
                var payMethod = payRow.getElementsByTagName('input')[0] as HTMLInputElement;
                checked = checked || payMethod.checked;
                payRow.addEventListener("click",
                    function() {
                        var i;
                        var inputList = document.getElementsByTagName('input');
                        for (i = 0; i < inputList.length; i++) {
                            inputList[i].checked = false;
                        }
                        payRow.getElementsByTagName('input')[0].checked = true;
                        radioChange(payRow.getElementsByTagName('input')[0]);
                    });
                payRow.style.cursor = 'pointer';
            });

            if (!checked && !upToFifty) {
                payOption[0].getElementsByTagName('input')[0].checked = true;
            }


            var close = $('#closePayModal');

            close.click(function () {
                ClosePayModal();
            });

            $('.modal-overlay').click(e => {
                ClosePayModal();
            })
        });

    var radioChange = function(elm) {

        if (!elm) {
            elm = this;
        }

        if (!elm.checked) {
            return;
        }


        var installmentSelected = elm.getAttribute("data-installment") === "1";


        if (upToFifty && !installmentSelected) {
            mainLink.removeAttribute('href');
            OpenPayModal();
            $('.ersal-table').find('input').prop('checked', false);
            payOptions.first().find('input').prop('checked', true);
            payOptions.parent().find('.PayOption').hide();
            var validations = payOptions.parent().find('span.validation');
            for (var i = 0; i < validations.length; i++) {
                window.ValidatorEnable(document.getElementById($(validations[i]).attr("id")), false);
            }
            payOptions.first().parent().find('.PayOption').show();
            validations = payOptions.first().parent().find('span.validation');
            for (var i = 0; i < validations.length; i++) {
                window.ValidatorEnable(document.getElementById($(validations[i]).attr("id")), true);
                $(validations[i]).hide();
            }
            mainLink.addEventListener('click', OpenPayModal);

        } else {
            mainLink.setAttribute('href', mainHref);
            mainLink.removeEventListener('click', OpenPayModal);
        }
    }
};

export {
    UpToFiftyCheck
};
